import { PassedInitialConfig } from 'angular-auth-oidc-client';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: 'https://public-api-stg.eventim.com/identity/auth/realms/platform-fr',
    strictIssuerValidationOnWellKnownRetrievalOff: true,
    redirectUrl: `${window.location.origin}/callback`,
    postLogoutRedirectUri: window.location.origin,
    clientId: 'frb-greenbox-tlm-dev__platform-fr',
    scope: 'openid profile offline_access email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: ['/api'],
  },
};
